import React, { useState, useEffect } from "react";
import "../../App.css";
import "./membership.scss";
import { getMemberListService } from "../../services/member.service";
import MemberTable from "../../features/member";
import MemberFormModal from "../../components/modals/MemberFormModal";

const MemberShip = () => {
  const [members, setMembers] = useState("");
  const getAllMembers = () => {
    const response = getMemberListService();
    return response;
  };

  useEffect(() => {
    getAllMembers()
      .then((res) => {

        const data = res.events.map(member => {

          const dob = member.ssn.slice(0, 4)
          const currentYear = new Date().getFullYear();
          const age = currentYear - dob
          return { ...member, age: age }
        })

        setMembers(data)
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <div className="membership">
      <div className="membership__member-table">
        <MemberFormModal getAllMembers={getAllMembers} />
        {Array.isArray(members) && members.length > 0 && (
          <MemberTable members={members} />
        )}
      </div>
    </div>
  );
};

export default MemberShip;
